import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.modal = new bootstrap.Modal(this.element)
    this.defaultDialogClasses = this.dialogTarget.className
  }

  open(event) {
    const frame = event.target
    const content = frame.firstElementChild

    if (!content) return

    const sizeClass = content.dataset.modalSize
    const positionClass = content.dataset.modalPosition

    this.resetDialogClasses()

    if (sizeClass) {
      this.dialogTarget.classList.add(sizeClass)
    }

    if (positionClass) {
      positionClass.split(" ").forEach(cls => {
        this.dialogTarget.classList.add(cls)
      })
    }

    if (!this.modal.isOpened) {
      this.modal.show()
    }
  }

  close(event) {
    if (event.detail.success) {
      this.modal.hide()
    }
  }

  resetDialogClasses() {
    this.dialogTarget.className = this.defaultDialogClasses
  }
}
